import { Action } from '../../actions';
import {
    ADD_FREELANCER_CARD_EDIT_SERVICE,
    CLOSE_FREELANCER_CARD_EDIT_IMAGE_POPUP,
    DELETE_FREELANCER_CARD_EDIT_SERVICE,
    FORMAT_FREELANCER_CARD_EDIT_SERVICE_PRICE,
    FREELANCER_CARD_EDIT_IMAGE_UPLOAD_ERROR,
    FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_ERROR,
    FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_START,
    FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_SUCCESS,
    FREELANCER_CARD_EDIT_IMAGE_UPLOAD_START,
    FREELANCER_CARD_EDIT_IMAGE_UPLOAD_SUCCESS,
    FREELANCER_CARD_EDIT_SET_SAVE_PROGRESS_STATUS,
    SET_FREELANCER_CARD_EDIT_IMAGE_CROP,
    SET_FREELANCER_CARD_EDIT_IMAGE_DATA,
    SET_INITIAL_FREELANCER_DATA_ERROR,
    UPDATE_FREELANCER_CARD_EDIT_BRIEF_INFO,
    UPDATE_FREELANCER_CARD_EDIT_CONTACT,
    UPDATE_FREELANCER_CARD_EDIT_SERVICE_DURATION,
    UPDATE_FREELANCER_CARD_EDIT_SERVICE_PRICE,
    UPDATE_INITIAL_FREELANCER_DATA,
    VALIDATE_FREELANCER_CARD_EDIT
} from '../../actions/freelancers/freelancer-card-edit';
import { FreelancerAccessErrorTypes } from '../../service/FreelancerAccessError';
import { NumberInputField } from '../../typings/common';
import {
    FREELANCER_SERVICE_DURATION_TYPES_ORDER,
    FreelancerCardEditState,
    FreelancerContactInputs,
    FreelancerContactTypes,
    FreelancerMandatoryContactTypes,
    FreelancerMandatoryContactTypesOrder,
    FreelancerOptionalContactTypes,
    FreelancerOptionalContactTypesOrder,
    FreelancerPageStates,
    FreelancerServiceInput,
    StringInputField,
    StringInputFieldErrors
} from '../../typings/freelancers';
import { CurrencyCode, GdFreelancerSkillOfferDuration } from '../../typings/graphql-grid';
import { State } from '../../typings/state';

const { MANDATORY_FIELD, INCORRECT_FORMAT } = StringInputFieldErrors;

const initialState: FreelancerCardEditState = {
    init: {
        avatarUrl: '',
        registrationDate: '',
        briefInfo: { inputVal: '' },
        contacts: {
            PHONE: {
                inputVal: ''
            },
            MAIL: {
                inputVal: ''
            }
        },
        services: []
    },
    edit: {
        avatarUrl: '',
        registrationDate: '',
        briefInfo: { inputVal: '' },
        contacts: {
            PHONE: {
                inputVal: ''
            },
            MAIL: {
                inputVal: ''
            },
            TELEGRAM: {
                inputVal: ''
            },
            VIBER: {
                inputVal: ''
            },
            SKYPE: {
                inputVal: ''
            }
        },
        services: []
    },
    certificates: [],
    services: [],
    serviceDurationTypes: FREELANCER_SERVICE_DURATION_TYPES_ORDER,
    currencyCode: CurrencyCode.RUB,
    isDataReadyToSave: true,
    pageStatus: FreelancerPageStates.PENDING,
    isImageUploading: false,
    isLocalImageUploading: false,
    isImagePopupOpen: false,
    imagePopupData: undefined,
    imagePopupCrop: {
        x: 0,
        y: 0,
        width: 100,
        height: 0,
        aspect: 1.8
    },
    messageError: undefined,
    countAttachImages: 0,
    initRegion: {
        region: '',
        country: ''
    },
    isSavingInProgress: false
};

export const freelancerCardEdit = (
    state: FreelancerCardEditState = initialState,
    action: Action,
    fullState: State
): FreelancerCardEditState => {
    switch (action.type) {
        case UPDATE_FREELANCER_CARD_EDIT_BRIEF_INFO:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    briefInfo: validateBriefInfo(action.value)
                },
                isDataReadyToSave: true
            };
        case UPDATE_FREELANCER_CARD_EDIT_CONTACT:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    contacts: {
                        ...state.edit.contacts,
                        [action.key]: validateSingleContact(action.key, action.value)
                    }
                },
                isDataReadyToSave: true
            };
        case UPDATE_FREELANCER_CARD_EDIT_SERVICE_PRICE:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    services: [
                        ...state.edit.services.slice(0, action.idx),
                        {
                            ...state.edit.services[action.idx],
                            price: validateSingleServicePrice(action.value)
                        },
                        ...state.edit.services.slice(action.idx + 1)
                    ]
                },
                isDataReadyToSave: true
            };
        case UPDATE_FREELANCER_CARD_EDIT_SERVICE_DURATION:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    services: [
                        ...state.edit.services.slice(0, action.idx),
                        {
                            ...state.edit.services[action.idx],
                            duration: {
                                inputVal: GdFreelancerSkillOfferDuration[action.value]
                            }
                        },
                        ...state.edit.services.slice(action.idx + 1)
                    ]
                }
            };
        case ADD_FREELANCER_CARD_EDIT_SERVICE:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    services: [
                        ...state.edit.services,
                        {
                            skillId: action.skillId,
                            price: {
                                inputVal: '',
                                numVal: 0
                            },
                            duration: {
                                inputVal: GdFreelancerSkillOfferDuration.NOT_DEFINED
                            }
                        }
                    ]
                },
                isDataReadyToSave: false
            };
        case DELETE_FREELANCER_CARD_EDIT_SERVICE:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    services: [
                        ...state.edit.services.slice(0, action.idx),
                        ...state.edit.services.slice(action.idx + 1)
                    ]
                }
            };
        case FORMAT_FREELANCER_CARD_EDIT_SERVICE_PRICE:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    services: state.edit.services.map((service, idx) => {
                        if (idx !== action.idx || service.price.error) {
                            return service;
                        }

                        return {
                            ...service,
                            price: {
                                ...service.price,
                                inputVal: formatSingleServicePrice(service.price.inputVal)
                            }
                        };
                    })
                }
            };
        case VALIDATE_FREELANCER_CARD_EDIT:
            return validateForm(state, action.freelancerRegionHasError);
        case UPDATE_INITIAL_FREELANCER_DATA:
            const { editData, servicesList, certificates, initRegion } = action.payload;

            return {
                ...state,
                init: editData,
                edit: editData,
                services: servicesList,
                certificates,
                initRegion,
                pageStatus: FreelancerPageStates.LOADED,
                isSavingInProgress: false
            };
        case SET_INITIAL_FREELANCER_DATA_ERROR:
            return {
                ...state,
                pageStatus:
                    action.errorType === FreelancerAccessErrorTypes.NO_DATA_PROVIDED
                        ? FreelancerPageStates.ERROR
                        : FreelancerPageStates.NO_ACCESS
            };
        case CLOSE_FREELANCER_CARD_EDIT_IMAGE_POPUP:
            return {
                ...state,
                isImagePopupOpen: false,
                imagePopupData: undefined,
                countAttachImages: state.countAttachImages + 1
            };
        case SET_FREELANCER_CARD_EDIT_IMAGE_DATA:
            return {
                ...state,
                imagePopupData: action.payload
            };
        case SET_FREELANCER_CARD_EDIT_IMAGE_CROP:
            if (action.payload) {
                return {
                    ...state,
                    imagePopupCrop: action.payload
                };
            } else {
                return {
                    ...state,
                    imagePopupCrop: initialState.imagePopupCrop
                };
            }
        case FREELANCER_CARD_EDIT_IMAGE_UPLOAD_START:
            return {
                ...state,
                isImageUploading: true
            };
        case FREELANCER_CARD_EDIT_IMAGE_UPLOAD_SUCCESS:
            return {
                ...state,
                isImageUploading: false,
                isImagePopupOpen: false,
                imagePopupData: undefined,
                countAttachImages: state.countAttachImages + 1,
                edit: {
                    ...state.edit,
                    avatarUrl: action.payload.url
                },
                avatarId: action.payload.id
            };
        case FREELANCER_CARD_EDIT_IMAGE_UPLOAD_ERROR:
            return {
                ...state,
                isImageUploading: false
            };
        case FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_START:
            return {
                ...state,
                isLocalImageUploading: true,
                messageError: undefined
            };

        case FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_SUCCESS:
            return {
                ...state,
                isLocalImageUploading: false,
                isImagePopupOpen: true
            };
        case FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_ERROR:
            return {
                ...state,
                isLocalImageUploading: false,
                messageError: action.messageError
            };
        case FREELANCER_CARD_EDIT_SET_SAVE_PROGRESS_STATUS:
            return {
                ...state,
                isSavingInProgress: action.value
            };
        default:
            return state;
    }
};

function validateSingleServicePrice(servicePrice: string): NumberInputField {
    const trimmedInputVal = formatSingleServicePrice(servicePrice);
    const price = parseInt(trimmedInputVal, 10);
    const isValid = trimmedInputVal === String(price) && price > 0;

    return {
        inputVal: servicePrice,
        numVal: price,
        error: isValid ? undefined : INCORRECT_FORMAT
    };
}

function formatSingleServicePrice(servicePrice: string): string {
    return servicePrice.replace(/^0+/, '');
}

function validateSingleService(service: FreelancerServiceInput, isFinalValidation: boolean): FreelancerServiceInput {
    const trimmedInputVal = formatSingleServicePrice(service.price.inputVal);
    const price = parseInt(trimmedInputVal, 10);
    const isInputValid = trimmedInputVal === String(price) && price > 0;

    if (!isFinalValidation) {
        return {
            ...service,
            price: {
                inputVal: trimmedInputVal,
                numVal: price,
                error: isInputValid ? undefined : INCORRECT_FORMAT
            }
        };
    }

    const isSelectValid = service.duration.inputVal !== GdFreelancerSkillOfferDuration.NOT_DEFINED;

    return {
        ...service,
        price: {
            inputVal: trimmedInputVal,
            numVal: price,
            error: isInputValid ? undefined : INCORRECT_FORMAT
        },
        duration: {
            inputVal: service.duration.inputVal,
            error: isSelectValid ? undefined : INCORRECT_FORMAT
        }
    };
}

function validateServices(state: FreelancerCardEditState): FreelancerServiceInput[] {
    const services = state.edit.services;

    return services.map(service => validateSingleService(service, true));
}

function validateSingleContact(key: FreelancerContactTypes, contact?: string): StringInputField | undefined {
    if (contact === undefined) {
        return;
    }

    switch (key) {
        case FreelancerMandatoryContactTypes.PHONE:
            return validatePhone(contact);
        case FreelancerMandatoryContactTypes.MAIL:
            return validateMail(contact);
        case FreelancerOptionalContactTypes.ICQ:
            return validateICQ(contact);
        case FreelancerOptionalContactTypes.TELEGRAM:
            return validateTelegram(contact);
        case FreelancerOptionalContactTypes.WEBSITE:
            return validateWebsite(contact);
        case FreelancerOptionalContactTypes.WHATSAPP:
            return validateWhatsapp(contact);
        case FreelancerOptionalContactTypes.VIBER:
            return validateViber(contact);
        case FreelancerOptionalContactTypes.SKYPE:
            return validateSkype(contact);
        default:
            throw new Error('invalid contact type');
    }
}

function validateContacts(state: FreelancerCardEditState): FreelancerContactInputs {
    const contacts = state.edit.contacts;
    const { MAIL, PHONE } = FreelancerMandatoryContactTypes;

    const newContacts = {
        MAIL: validateMail(contacts[MAIL].inputVal),
        PHONE: validatePhone(contacts[PHONE].inputVal)
    };

    return FreelancerOptionalContactTypesOrder.reduce((accumulator, key) => {
        const contact = contacts[key] && contacts[key]!.inputVal;
        if (!contact) {
            return accumulator;
        }
        switch (key) {
            case FreelancerOptionalContactTypes.ICQ:
                return {
                    ...accumulator,
                    [key]: validateICQ(contact)
                };
            case FreelancerOptionalContactTypes.TELEGRAM:
                return {
                    ...accumulator,
                    [key]: validateTelegram(contact)
                };
            case FreelancerOptionalContactTypes.WEBSITE:
                return {
                    ...accumulator,
                    [key]: validateWebsite(contact)
                };
            case FreelancerOptionalContactTypes.WHATSAPP:
                return {
                    ...accumulator,
                    [key]: validateWhatsapp(contact)
                };
            case FreelancerOptionalContactTypes.VIBER:
                return {
                    ...accumulator,
                    [key]: validateViber(contact)
                };
            case FreelancerOptionalContactTypes.SKYPE:
                return {
                    ...accumulator,
                    [key]: validateSkype(contact)
                };
            default:
                return accumulator;
        }
    }, newContacts);
}

export const BRIEF_INFO_MAX_LENGTH = 10000;
export const BRIEF_INFO_MIN_LENGTH = 5;

export function validateBriefInfo(inputVal: string): StringInputField {
    return {
        inputVal: inputVal,
        error:
            inputVal.length <= BRIEF_INFO_MAX_LENGTH && inputVal.length >= BRIEF_INFO_MIN_LENGTH
                ? undefined
                : INCORRECT_FORMAT
    };
}

const MAIL_PTRN = /^\S+@\S+\.\S+$/;

function validateMail(contact: string): StringInputField {
    const trimmedContactVal = contact.trim();
    return {
        inputVal: trimmedContactVal,
        error: !trimmedContactVal ? MANDATORY_FIELD : trimmedContactVal.match(MAIL_PTRN) ? undefined : INCORRECT_FORMAT
    };
}

const PHONE_PTRN = /^\+?[0-9\-\s\(\)]+$/;
const PHONE_REPLACE_PTRN = /\D/g;
const PHONE_NUMBER_MIN_LENGTH = 9;
const PHONE_NUMBER_MAX_LENGTH = 15;

function validatePhone(contact: string): StringInputField {
    const trimmedContactVal = contact.trim();
    const phoneNumbers = trimmedContactVal.replace(PHONE_REPLACE_PTRN, '');

    return {
        inputVal: trimmedContactVal,
        error: !trimmedContactVal
            ? MANDATORY_FIELD
            : trimmedContactVal.match(PHONE_PTRN) &&
              phoneNumbers.length >= PHONE_NUMBER_MIN_LENGTH &&
              phoneNumbers.length <= PHONE_NUMBER_MAX_LENGTH
            ? undefined
            : INCORRECT_FORMAT
    };
}

const ICQ_PTRN = /^\d{5,10}$/;

function validateICQ(contact: string): StringInputField {
    const trimmedContactVal = contact.trim();

    return {
        inputVal: trimmedContactVal,
        error: trimmedContactVal.match(ICQ_PTRN) || !trimmedContactVal ? undefined : INCORRECT_FORMAT
    };
}

const TELEGRAM_PTRN = /^\w{5,32}$/;

function validateTelegram(contact: string): StringInputField {
    const trimmedContactVal = contact.trim();

    return {
        inputVal: trimmedContactVal,
        error: trimmedContactVal.match(TELEGRAM_PTRN) || !trimmedContactVal ? undefined : INCORRECT_FORMAT
    };
}

const WEBSITE_PTRN = /^(?:https?:\/\/)?\S+\.\S+$/;

function validateWebsite(contact: string): StringInputField {
    const trimmedContactVal = contact.trim();

    return {
        inputVal: trimmedContactVal,
        error: trimmedContactVal.match(WEBSITE_PTRN) || !trimmedContactVal ? undefined : INCORRECT_FORMAT
    };
}

function validateWhatsapp(contact: string): StringInputField {
    const phone = validatePhone(contact);

    return {
        inputVal: phone.inputVal,
        error: phone.error === INCORRECT_FORMAT ? INCORRECT_FORMAT : undefined
    };
}

function validateViber(contact: string): StringInputField {
    const viber = validatePhone(contact);

    return {
        inputVal: viber.inputVal,
        error: viber.error === INCORRECT_FORMAT ? INCORRECT_FORMAT : undefined
    };
}

const SKYPE_PTRN = /^[A-Za-z][0-9A-Za-z_\-.:]{5,32}$/;

function validateSkype(contact: string): StringInputField {
    const trimmedSkypeVal = contact.trim();

    return {
        inputVal: trimmedSkypeVal,
        error: trimmedSkypeVal.match(SKYPE_PTRN) || !trimmedSkypeVal ? undefined : INCORRECT_FORMAT
    };
}

function validateForm(state: FreelancerCardEditState, freelancerRegionHasError: boolean): FreelancerCardEditState {
    const contacts = validateContacts(state);
    const services = validateServices(state);
    const briefInfo = validateBriefInfo(state.edit.briefInfo.inputVal);

    const isPageValid =
        services.reduce(
            (isFormValid, service) => isFormValid && !service.price.error && !service.duration.error,
            true
        ) &&
        [...FreelancerMandatoryContactTypesOrder, ...FreelancerOptionalContactTypesOrder].reduce((isFormValid, key) => {
            const contact = contacts[key];
            if (!contact) {
                return isFormValid;
            }
            return isFormValid && !contact.error;
        }, true) &&
        !freelancerRegionHasError &&
        !briefInfo.error;

    return {
        ...state,
        edit: {
            ...state.edit,
            briefInfo,
            contacts,
            services
        },
        isDataReadyToSave: isPageValid
    };
}
